module.exports = "/dist/ffe5c79b34f32dd525a543310b03c405.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-300.eot
// module id = 10
// module chunks = 0